module.exports = __webpack_public_path__ + "static/media/unknown.9db4d060.jpeg";